import React from 'react';
import '../App.css';
import Headerappprivate from './appPrivate/headerappprivate'
import { Bodyappordenesreportbody} from './bodyappordenesreportbody'
import { Footerappprivate } from './appPrivate/footerappprivate'
import withRouter from './withRouter'
class Bodyappordenesreport extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivate/>
        <Bodyappordenesreportbody />
        <Footerappprivate/>
      </div>
    );
  }
}
export default withRouter(Bodyappordenesreport);